import React, { useEffect, useState } from "react";
import { emergencyContactType } from "../../../../common/interfaces/myProfile/personalDetails/emergencyContactType";
import { useAppSelector } from "../../../../infra/hooks";
import DTOEmergencyContact from "./DTOEmergencyContact";
import EmergencyContactPresenter from "./EmergencyContactPresenter";
import { useTranslation } from "react-i18next";
function EmergencyContactController() {
  const { t, i18n } = useTranslation();
  const [emergencyContactData, setEmergencyContactData] =
    useState<emergencyContactType>({
      emergencyContactNumber: 0,
      emergencyPersonName: "",
      emergencyCountry: "",
      emergencyEmail: "",
      emergencyRelationship: "",
    });
  const [cardUpdate, setCardUpdate] = useState<boolean>(false);

  function callBackFunc(data: emergencyContactType) {
    setEmergencyContactData(data);
  }
  const callBackCardUpdate = (card: boolean) => {
    setCardUpdate(card);
  };
  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);

  return (
    <div>
      <DTOEmergencyContact setEmergencyContactInfo={callBackFunc} />
      <EmergencyContactPresenter
        emergencyData={emergencyContactData}
        isCardUpdate={callBackCardUpdate}
        hr_view={hr_view}
        trans={t}
      />
    </div>
  );
}

export default EmergencyContactController;
